<label [id]="id" class="form-label fs-3 fw-bold">{{
  fieldDefinition.label
}}</label>
<div
  [ngClass]="['competency', inputDisabled ? 'disabled' : '']"
  *ngIf="formCompetency && indicatorGroups">
  <h4 class="fw-bold" *ngIf="selectedCompetency">
    {{ selectedCompetency.title }} ({{ selectedCompetency.rubric_name }})
  </h4>
  <span *ngIf="!inputDisabled" class="d-block mt-2 mb-1"
    >Check off the behaviors you observe:</span
  >
  <ng-container *ngFor="let indicatorGroup of indicatorGroups; let last = last">
    <h5>{{ indicatorGroup.title }}</h5>
    <div class="d-flex flex-nowrap" style="overflow-x: auto">
      <div
        class="level-card competency-card card d-flex flex-column"
        style="min-width: 200px"
        *ngFor="let indicator of indicatorGroup.indicators"
        (click)="selectIndicator(indicator)">
        <div
          [ngClass]="[
            'bg-level-' + indicator.level,
            'card-header',
            'section-header',
            'text-light',
            'fs-5',
            'text-end',
            'text-nowrap',
            'align-middle'
          ]">
          Level
          <i class="bi bi-{{ indicator.level }}-circle"></i>
        </div>
        <div class="d-flex justify-content-between p-3">
          <div class="indicator-container">
            <i
              [ngClass]="[
                'bi',
                'bi-circle',
                'position-absolute',
                'fs-5',
                this.indicatorsChecked.includes(indicator.id)
                  ? 'color-active'
                  : 'color-gray'
              ]"></i>
            <i
              *ngIf="this.indicatorsChecked.includes(indicator.id)"
              class="bi bi-check-lg fs-4 color-active"></i>
          </div>
          <span class="fs-13">{{ indicator.title }}</span>
        </div>
      </div>
    </div>
    <div
      #guidanceContainer
      *ngIf="indicatorGroup.sampleQuestions && last && !inputDisabled"
      class="guidance">
      <div class="questions bg-secondary">
        <div class="p-3" [innerHTML]="indicatorGroup.sampleQuestions"></div>
      </div>
      <button
        class="btn fw-bold d-inline-block"
        (click)="guidanceContainer.classList.toggle('showQuestions')">
        Guiding Questions
      </button>
    </div>
  </ng-container>
</div>
